module.exports = __webpack_public_path__ + "static/media/user_marker_icon.0de3ce2f.png";